// extracted by mini-css-extract-plugin
export default {"login-container":"Frontpage_login-container__ocmtO","something":"Frontpage_something__0SRt2","login":"Frontpage_login__VI9uy"};